import { FormRegistration } from '@/components/form-registration-v4';
import { HeaderMenu } from '@/components/header-menu';
import { useAuth } from '@/store/useAuth';
import { Spiner } from '@/ui-kit';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './registrationV4.module.scss'

export const RegistrationV4 = () => {
    const [isLoadingOnce, setIsLoadingOnce] = useState(true);
    const userData = useAuth((state) => state.getUser());
    const { stepNumer } = useParams();
    return userData ? (
        <>
            <HeaderMenu append={
                <span className={styles.progressCounter}>
                    {`${stepNumer}/6`}
                </span>
            }>
                <div
                    className={styles.progress}>
                    <div className={styles.progressbar}>
                        <div style={{ width: `${100 / 6 * parseInt(stepNumer ?? '0')}%` }} className={styles.progressbarActive} />
                    </div>
                </div>
            </HeaderMenu>
            <FormRegistration
                step={stepNumer}
                isLoadingOncePage={isLoadingOnce}
                onChangeIsLoadingPage={setIsLoadingOnce} />
        </>
    ) : (
        <Spiner />
    );
};
